import React, { Fragment } from "react";
import { Helmet } from "react-helmet";
import { headConstants } from "@utils/constants";
import CommonHead from "./metas/Common";

export const NonIndexableHead = () => {
  return (
    <Fragment>
      <Helmet>
        <title>{headConstants.healthyWeightTitle}</title>
        <meta
          name="description"
          content={headConstants.healthyWeightDescription}
        />
        <meta name="robots" content="noindex" />
      </Helmet>
      <CommonHead />
    </Fragment>
  );
};
